import type {
  CalendarFeedSummary,
  CalendarOccurrence,
  CalendarRange,
  NewCalendarFeedInput,
} from '@fc/core'
import { apiFetch } from './api'

export type { CalendarFeedSummary, CalendarOccurrence, CalendarRange } from '@fc/core'

/** Fetch occurrences in [from, to) (ISO strings), optionally filtered by site. */
export async function getCalendarRange(params: {
  from: string
  to: string
  siteId?: string | null
}): Promise<CalendarRange> {
  const qs = new URLSearchParams({ from: params.from, to: params.to })
  if (params.siteId) qs.set('site', params.siteId)
  return apiFetch<CalendarRange>(`/calendar?${qs.toString()}`)
}

export const listCalendarFeeds = () => apiFetch<CalendarFeedSummary[]>('/calendar/feeds')

export const createCalendarFeed = (input: NewCalendarFeedInput) =>
  apiFetch<CalendarFeedSummary>('/calendar/feeds', {
    method: 'POST',
    body: JSON.stringify(input),
  })

export const deleteCalendarFeed = (id: string) =>
  apiFetch<void>(`/calendar/feeds/${id}`, { method: 'DELETE' })
